import { Onboarding } from './Onboarding';

export { Onboarding };
// Used for dynamic import
export default Onboarding;
